module.exports = __webpack_public_path__ + "img/crown.260db655.svg";